<template>
  <!-- メイン画面 -->
  <div class="content-wrapper">
    <TemplateDbsMyReport v-if="isReadyToDraw" />
    <DialogInitialLoading v-else />
  </div>
  <!-- メイン画面 -->
</template>

<script>
import { onMounted, ref } from "vue";
import API from "@/API";

import TemplateDbsMyReport from "@/views/Templates/Dbs/TemplateDbsMyReport";

export default {
  name: "DbsMyReport",
  components: {
    TemplateDbsMyReport,
  },
  setup() {
    const isReadyToDraw = ref(false);

    onMounted(async () => {
      await API.getDbsReportsForPast();
      isReadyToDraw.value = true;
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
